<template>
    <div>
        <Header />
        <PageTitle />
        <BlogRightSidebarContent />
        <Footer />
    </div>
</template>

<script>
import Header from '../Layout/Header'
import PageTitle from '../BlogRightSidebar/PageTitle'
import BlogRightSidebarContent from '../BlogRightSidebar/BlogRightSidebarContent'
import Footer from '../Layout/Footer'

export default {
    name: 'BlogRightSidebarPage',
    components: {
        Header,
        PageTitle,
        BlogRightSidebarContent,
        Footer,
    }
}
</script>